/**
 * Проверка версии приложения: при появлении новой версии на сервере
 * вызывается onNewVersion (баннер + автообновление через 30 с) или сразу перезагрузка.
 */

import { BUILD_VERSION } from '../buildVersion';

const VERSION_URL = `${process.env.PUBLIC_URL || ''}/version.json`;

const DEFAULT_POLL_INTERVAL_MS = 60 * 1000; // 1 раз в минуту, чтобы заметить деплой пока вкладка открыта

/**
 * Загружает текущую версию с сервера (без кэша) и сравнивает с версией в бандле.
 * Возвращает true, если на сервере версия отличается (есть обновление).
 */
export async function checkForNewVersion() {
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return false;
    const data = await res.json();
    const serverVersion = data?.version;
    if (typeof serverVersion !== 'string') return false;
    return serverVersion !== BUILD_VERSION;
  } catch (e) {
    return false;
  }
}

/**
 * Запускает проверку версии: при загрузке, при возврате на вкладку и по таймеру.
 * Если передать onNewVersion, при новой версии вызывается он (показать баннер + автообновление через 30 с).
 * Если не передать — при новой версии страница перезагружается сразу (как раньше).
 *
 * @param {{ onNewVersion?: () => void, pollIntervalMs?: number }} options
 */
export function startVersionCheck(options = {}) {
  const { onNewVersion, pollIntervalMs = DEFAULT_POLL_INTERVAL_MS } = options;

  const runCheck = async () => {
    const hasNew = await checkForNewVersion();
    if (!hasNew) return;
    console.log('[VersionCheck] New version available — current:', BUILD_VERSION);
    if (onNewVersion && typeof onNewVersion === 'function') {
      onNewVersion();
    } else {
      window.location.reload();
    }
  };

  runCheck();

  const onVisible = () => {
    if (document.visibilityState === 'visible') runCheck();
  };
  document.addEventListener('visibilitychange', onVisible);

  const pollId = setInterval(runCheck, pollIntervalMs);

  return () => {
    document.removeEventListener('visibilitychange', onVisible);
    clearInterval(pollId);
  };
}
